<template>
  <section class="dialogBind">
    <el-dialog
      :close-on-click-modal="false"
      center
      :title="argument.title"
      :visible="true"
      width="500px"
      top="30vh"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <div class="container" v-if="step === 1">
        <el-form>
          <ul>
            <li v-if="type === 1 && argument.oldPhoneOrEmail">
              <span>{{$t('global.原手机号')}}</span>
              <input
                type="text"
                v-model="form.oldPhone"
                :placeholder="`${$t('global.请将手机号')}${$jsonUtils.accountCut(argument.oldPhoneOrEmail,'phone')}${$t('global.补充完整')}`"
              />
            </li>
            <li v-if="type === 2 && argument.oldPhoneOrEmail">
              <span>{{$t('global.原邮箱')}}</span>
              <input
                type="text"
                v-model="form.oldEmail"
                :placeholder="`${$t('global.请将邮箱')}${$jsonUtils.accountCut(argument.oldPhoneOrEmail,'email')}${$t('global.补充完整')}`"
              />
            </li>
            <li v-if="type === 2">
              <span>{{$t('global.邮箱')}}</span>
              <input
                type="text"
                v-model="form.email"
                :placeholder="argument.oldPhoneOrEmail?this.$t('global.输入新邮箱地址'):this.$t('global.输入邮箱地址')"
              />
            </li>
            <li v-if="type === 1">
              <el-select
                v-model="form.areaCode"
                filterable
                remote
                :remote-method="getSearch"
                :placeholder="$t('global.请选择区号')"
                class="areaCode"
              >
                <el-option
                  :label="item.areaCode"
                  :value="item.areaCode"
                  v-for="item in areaCodeList"
                  :key="item.id"
                >
                  <p>
                    {{item.title}}
                    <span style="padding-left:10px;float: right;">{{item.areaCode}}</span>
                  </p>
                </el-option>
              </el-select>

              <el-form-item prop="phone" class="phone">
                <el-input
                  type="text"
                  v-model="form.phone"
                  :placeholder="argument.oldPhoneOrEmail?this.$t('global.输入新的手机号'):this.$t('global.输入手机号')"
                ></el-input>
              </el-form-item>
            </li>
            <li v-if="type === 1 || type === 2">
              <span>{{$t('global.验证码')}}</span>
              <el-form-item prop="code" class="phoneCode">
                <el-input type="text" v-model="form.code" :placeholder="$t('global.验证码')"></el-input>
                <a
                  href="javascript:;"
                  class="sendCode"
                  @click.prevent="checkAccount"
                >{{!time?this.$t('global.获取验证码'):`${time}s${this.$t('global.后重新获取')}`}}</a>
              </el-form-item>
            </li>
            <li v-if="type === 3">
              <span>{{$t('global.旧密码')}}</span>
              <input type="password" v-model="form.oldPassword" :placeholder="$t('global.请输入旧密码')" />
            </li>
            <li v-if="type === 3">
              <span>{{$t('global.新密码')}}</span>
              <input
                type="password"
                v-model="form.newPassword"
                :placeholder="$t('global.密码不少于7位，且不能为纯数字')"
              />
            </li>
          </ul>
        </el-form>
      </div>
      <div class="container cancel" v-if="step === 2">
        <p v-for="(item,index) in cancelObj.p" :key="index">{{item}}</p>
        <h5 v-for="(item,index) in cancelObj.h" :key="index">{{item}}</h5>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit" v-if="step === 1">{{$t('global.提 交')}}</el-button>
        <el-button type="primary" @click="unbinding" v-if="step === 2">{{$t('global.确认解绑')}}</el-button>
        <el-button type="primary" plain @click="handleClose" v-if="step === 2">{{$t('global.暂不解绑')}}</el-button>
        <a
          href="javascript:;"
          class="marge"
          @click="merge"
          v-if="step === 2"
        >{{$t('global.申请合并这些账号')}}</a>
      </span>
    </el-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        oldPhone: "",
        oldEmail: "",
        phone: "",
        email: "",
        code: "",
        newPassword: "",
        oldPassword: "",
        areaCode: "86"
      },
      areaCodeList: [],
      time: 0,
      step: 1,
      cancelObj: {
        p: [],
        h: []
      }
    };
  },
  props: {
    type: {
      type: Number,
      default: 1 /**1 $t('global.手机') , 2 $t('global.邮箱') */
    },
    argument: {
      type: Object
    },
    close: {
      type: Function
    }
  },

  watch: {
    time(val) {
      if (val >= 1) {
        setTimeout(() => {
          this.time--;
        }, 1000);
      }
    }
  },
  created() {
    if (this.type === 1) {
      this.getAreaCodeList("");
    }
  },
  methods: {
    submit() {
      switch (this.type) {
        case 1:
        case 2:
          if (
            this.form.code &&
            ((this.form.phone && this.form.areaCode) || this.form.email)
          ) {
            if (
              !this.form.oldPhone &&
              !this.form.oldEmail &&
              this.argument.oldPhoneOrEmail
            ) {
              this.$message.info(this.$t("global.请将原账号补充完整"));
              return;
            }
            this.bind();
          }
          break;
        default:
          if (this.form.oldPassword && this.form.newPassword) {
            if (
              /\S{7,}/.test(this.form.newPassword) &&
              !/^\d+$/.test(this.form.newPassword)
            ) {
              this.changePassword();
            } else {
              this.$message.error(
                this.$t("global.密码不少于7位，且不能为纯数字")
              );
            }
          } else {
            this.$message.warn(this.$t("global.请填写旧密码和新密码"));
          }
          break;
      }
    },
    changePassword() {
      const url = `/api/u/password/change`;
      const params = {
        oldPassword: this.form.oldPassword,
        newPassword: this.form.newPassword,
        confirmPassword: this.form.newPassword
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.handleClose();
        }
      });
    },
    bind() {
      const url = `/api/user/b/binding`;
      const params = {
        code: this.form.code,
        type: this.type,
        oldPhoneOrEmail: this.form.oldPhone || this.form.oldEmail || undefined,
        areaCode: this.type === 1 ? "+" + this.form.areaCode : undefined,
        phoneOrEmail: this.form.phone || this.form.email
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          if (res.data && res.data.otherUserInfo) {
            this.step = 2;
            const otherUserInfo = res.data.otherUserInfo;
            this.cancelObj = {
              p: [
                `${
                  this.type === 1
                    ? this.$t("global.手机号")
                    : this.$t("global.邮箱")
                } +${this.form.areaCode}${this.form.phone} ${`${this.$t(
                  "global.已经被绑定到账号"
                )} 「` +
                  otherUserInfo
                    .map(item => item.nickName)
                    .join("」「")}」${this.$t("global.等")}${
                  otherUserInfo.length
                }${this.$t("global.个账号")}。`,
                `${this.$t("global.你可以选择将该")}${
                  this.type === 1
                    ? this.$t("global.手机号")
                    : this.$t("global.邮箱")
                }${this.$t("global.从")}「${otherUserInfo
                  .map(item => item.nickName)
                  .join("」「")}」${this.$t("global.等")}${
                  otherUserInfo.length
                }${this.$t("global.个账号中解绑")}，${this.$t(
                  "global.并绑定到当前账号"
                )}「${this.$store.state.peopleMessage.nickname}」。`
              ],
              h: []
            };
            let arr1 = [];
            let arr2 = [];
            otherUserInfo.map(item => {
              if (this.type === 1) {
                if (!item.email && !this.bindThird) {
                  arr1.push(item.nickName);
                } else {
                  arr2.push(item.nickName);
                }
              } else if (this.type === 2) {
                if (!item.phone && !this.bindThird) {
                  arr1.push(item.nickName);
                } else {
                  arr2.push(item.nickName);
                }
              }
            });
            if (this.type === 1) {
              if (arr1.length) {
                this.cancelObj.h.push(
                  ` ${this.$t("global.原账号")}「${arr1.join(
                    "」「"
                  )}」${this.$t(
                    "global.未绑定任何邮箱和第三方账号"
                  )}。${this.$t("global.解绑后")}，${this.$t(
                    "global.原账号"
                  )}「${arr1.join("」「")}」${this.$t(
                    "global.将永远无法再登录"
                  )}。`
                );
              }
              if (arr2.length) {
                this.cancelObj.h.push(
                  ` ${this.$t("global.解绑后")}，${this.$t(
                    "global.你将无法再通过该手机号登录原账号"
                  )}「${arr2.join("」「")}」。`
                );
              }
            } else if (this.type === 2) {
              if (arr1.length) {
                this.cancelObj.h.push(
                  ` ${this.$t("global.原账号")}「${arr1.join(
                    "」「"
                  )}」${this.$t(
                    "global.未绑定任何手机号和第三方账号"
                  )}。${this.$t("global.解绑后")}，${this.$t(
                    "global.原账号"
                  )}「${arr1.join("」「")}」${this.$t(
                    "global.将永远无法再登录"
                  )}。`
                );
              }
              if (arr2.length) {
                this.cancelObj.h.push(
                  ` ${this.$t("global.解绑后")}，${this.$t(
                    "global.你将无法再通过该邮箱登录原账号"
                  )}「${arr2.join("」「")}」。`
                );
              }
            }
          } else {
            if (this.form.phone) {
              this.$store.dispatch("setAccountUser", {
                ...this.$store.state.accountUser,
                phone: this.form.phone
              });
            }
            // this.handleClose();
            this.handleConfirm();
          }
        }
      });
    },
    unbinding() {
      const url = `/api/user/b/unbinding`;
      const params = {
        areaCode: this.form.areaCode ? "+" + this.form.areaCode : undefined,
        phoneOrEmail: this.form.phone || this.form.email,
        type: this.type
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.$message.success(res.message);
          this.handleClose();
        }
      });
    },
    handleClose() {
      this.$emit("close");
    },
    handleConfirm() {
      this.$emit("confirm");
    },
    getAreaCodeList(val) {
      let config = {
        loading: false,
        params: {
          keyWords: val || undefined,
          pageSize: 500,
          pageIndex: 1,
          orderBy: "createTime"
        }
      };
      let $this = this;
      this.$http.get("/api/areacode/areaCodeList", config).then(response => {
        this.areaCodeList = response.data.list;
      });
    },
    getSearch(val) {
        if (!val) {
          this.getAreaCodeList("");
        } else {
          this.areaCodeList = this.areaCodeList.filter((item)=>{
                return (item.title).indexOf(val.toUpperCase()) > -1 || (item.areaCode).indexOf(val) > -1
          })
        }
    },
    checkAccount() {
      if (!this.time) {
        if (this.form.email || this.form.phone) {
          let params = {
            phone: this.form.email,
            type: this.type
          };
          if (this.type === 1) {
            params.areaCode = "+" + this.form.areaCode;
            params.phone = this.form.phone;
          }
          const url = `/api/customer/sendPhoneOrEmailCode`;
          this.$http.post(url, params).then(res => {
            if (res.code === "OK") {
              this.$message.success(this.$t("global.验证码已发送"));
              this.time = 60;
            }
          });
        } else {
          this.$message(this.$t("global.请输入绑定的账号"));
        }
      }
    },
    merge() {
      const url = `/api/user/b/applyAccountMerge`;
      const params = {
        areaCode: this.form.areaCode ? "+" + this.form.areaCode : undefined,
        phoneOrEmail: this.form.phone || this.form.email,
        type: this.type
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.$message({
            type: "success",
            message: res.message
          });
          this.handleClose();
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.el-dialog__body {
  .container {
    width: 100%;

    ul {
      padding: 0 40px 40px;

      li {
        border-bottom: 1px solid #eaebec;
        display: flex;
        flex-direction: row;
        padding: 20px 0 5px;

        .areaCode {
          width: 120px;
        }

        span {
          color: #333;
          line-height: 40px;
          width: 120px;
        }

        input {
          flex: 1;
        }

        .el-form-item {
          flex: 1;
          margin-bottom: 0;

          .el-form-item__content {
            position: relative;

            input {
              border: 0;
            }

            .sendCode {
              position: absolute;
              right: 20px;
              top: 0;
              color: #5f86fc;
            }
          }
        }
      }
    }
  }

  .container.cancel {
    p, h5 {
      color: #333;
      line-height: 20px;
      padding-bottom: 20px;
      font-size: 14px;
    }
  }
}
</style>
<style lang="stylus">
.dialogBind {
  .el-dialog__header {
    border-bottom: 1px solid #eaebec;
  }

  .el-form-item {
    flex: 1;

    &.phoneCode {
      input {
        margin: 0;
      }
    }

    .el-form-item__content {
      input {
        border: 0;
        padding: 0;
      }
    }
  }

  .areaCode {
    .el-input--suffix {
      input {
        border: none;
      }
    }

    .el-input--suffix {
      .el-input__suffix-inner {
        .el-select__caret {
          color: #c0c4cc;
          font-size: 14px;
          transition: transform 0.3s;
          transform: rotate(180deg);
          cursor: pointer;
          height: 40px;

          &:before {
            content: '\e6e1';
          }

          &:after {
            content: '';
            height: 100%;
            width: 0;
            display: inline-block;
            vertical-align: middle;
          }

          &.is-reverse {
            transform: rotate(0deg);
          }
        }
      }
    }
  }

  .el-dialog__footer {
    padding-bottom: 40px;

    .el-button {
      width: 60%;
      height: 40px;
      margin-bottom: 10px;
      margin-left: 0;

      &:not(.is-plain) {
        background: #3664ED;
      }
    }

    .marge {
      display: block;
      color: #3664ED;
      padding: 10px;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/pages/dialog/BindDialog.vue